import {createSelector} from 'reselect';

const selectDrawer = (state) => state.drawer;

export const makeSelectIsDrawerVisible = () => createSelector([selectDrawer], (drawer) => drawer.isVisible);

export const makeSelectDrawerContentType = () => createSelector([selectDrawer], (drawer) => drawer.contentType);
